import { call, put, select, takeLatest } from 'redux-saga/effects'
import { BillingConstants } from '../../billing/store/billing.constants'
import { IPcr } from '../../pcr/store/pcr.types'
import { setInsuranceInformationState } from '../store/insuranceInformation.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getPcrIdSelector } from '../../home/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'

export function* setInsuranceInformation(pcrDoc: IPcr) {
  const insuranceInformation = pcrDoc.billing?.insuranceInformation
  if (insuranceInformation && Object.keys(insuranceInformation).length !== 0) {
    yield put(setInsuranceInformationState(insuranceInformation))
  }
}

export function* preloadPCR() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!pcrID) return

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    yield call(setInsuranceInformation, pcrDoc)
  } catch (e) {
    yield put(throwPcrException(`preloadPCR() error in setInsuranceInformation.saga.ts: ${e}`))
  }
}

export function* setInsuranceInformationSaga() {
  yield takeLatest([BillingConstants.REFRESH_BILLING_DATA], performWithMutexHOG, preloadPCR)
}
